import classNames from "classnames/bind";
import styles from './InProcessBuild.module.css';
import settingImage from '../../assets/images/settings.png';
const cx = classNames.bind(styles);

function InProcessBuild({ title }) {
    return (
        <div className={cx('modal')}>
            <div className={cx('container')}>
                <div className={cx('image')}>
                    <img src={settingImage} alt={'error'} />
                </div>
                <div className={cx('title')}>
                    {title ? title : 'Chức năng đang phát triển!'}
                </div>
            </div>
        </div>
    )
}

export default InProcessBuild;